import { createContext, useContext, useState, useEffect } from 'react';
import supabase from '../helper/supabaseClient';

const UserProfileContext = createContext();

export const UserProfile = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchProfile = async () => {
    const {
      data: { user },
      error: userError
    } = await supabase.auth.getUser();

    if (userError || !user) {
      setLoading(false);
      return;
    }

    const { data, error } = await supabase
      .from('profile')
      .select(`*, reval_members(*, reval_member_qualifications(*))`)
      .eq('id', user.id)
      .single();

    if (!error) {
      setProfile(data);
    }

    setLoading(false);
  };

  useEffect(()=> {
    fetchProfile();
  }, []);
  

console.log(profile)

  return (
    <UserProfileContext.Provider value={{ 
      profile,
      setProfile,
      loading,
      refreshProfile: fetchProfile
       }}>
      {children}
    </UserProfileContext.Provider>
  );
};

export const useUserProfile = () => useContext(UserProfileContext);
